import React from "react";
import { CloseIcon } from "../../../../../../components/icons"
import { useBookingEditText } from "../../../text";

const DiscardEditConfirmationModal = ({
    show,
    onClose,
    handleDiscardEdit,
    isSubmittingModification
}) => {
    const { t } = useBookingEditText();
    return (
        <div className={`tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center ${show ? 'tw:block' : 'tw:hidden'}`}>
            <div
                aria-label="Close modal backdrop"
                className="tw:absolute tw:inset-0 tw:bg-[#00000099]"
                onClick={onClose}
            />
            <div className="tw:relative tw:z-[10000] tw:w-[calc(100%-24px)] tw:lg:w-[660px] tw:rounded-[8px] tw:bg-white tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8 tw:shadow-lg">
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close"
                    className="tw:absolute tw:top-6 tw:right-6"
                >
                    <CloseIcon color="#7c7b7b" size={16} />
                </button>

                <div className="tw:!text-center tw:!mt-4 tw:!mb-6">
                    <p className="tw:!text-[#282828] tw:!mb-2 tw:!text-[18px] tw:!font-[600] tw:font-hanken-grotesk tw:max-w-full">
                        {t("editBooking.BookingReviewPage.discardConfirmationModal.title")}
                    </p>
                    {t("editBooking.BookingReviewPage.discardConfirmationModal.subtitle") ? (
                        <p className="tw:!text-[#8D8D8D] tw:!mb-0 tw:!text-[15px] tw:!font-[400] tw:font-hanken-grotesk">
                            {t("editBooking.BookingReviewPage.discardConfirmationModal.subtitle")}
                        </p>
                    ) : null}
                </div>

                <div className="tw:flex tw:flex-col tw:lg:flex-row tw:items-stretch tw:gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isSubmittingModification}
                        className="tw:flex-1"
                    >
                        <div className="tw:!py-3 tw:w-full tw:md:flex-1 tw:rounded-[8px] tw:border tw:border-[#d0d0d0] tw:bg-white tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:font-medium tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            {t("editBooking.BookingReviewPage.discardConfirmationModal.back")}
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={handleDiscardEdit}
                        disabled={isSubmittingModification}
                        className="tw:flex-1"
                    >
                        <div className="tw:!py-3 tw:w-full tw:md:flex-1 tw:rounded-[8px] tw:bg-[#f3f3f3] tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:!font-[700] tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            {t("editBooking.BookingReviewPage.discardConfirmationModal.discardEdit")}
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DiscardEditConfirmationModal;
